<button type="button"
  class="column-filter-trigger"
  [class.active]="isActive"
  [class.open]="isOpen"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  [attr.aria-label]="'Filter ' + header"
  [title]="isActive ? 'Filtered - click to change' : 'Filter ' + header"
  (click)="open($event)">
  @if (isActive) {
    <svg class="trigger-icon" viewBox="0 0 24 24" width="12" height="12" aria-hidden="true">
      <path d="M3 4h18l-7 8.2V19l-4 2v-8.8z" fill="currentColor"/>
    </svg>
  } @else {
    <svg class="trigger-icon" viewBox="0 0 10 6" width="10" height="6" aria-hidden="true">
      <path d="M0 0h10L5 6z" fill="currentColor"/>
    </svg>
  }
</button>

<ng-template cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="close()"
  (detach)="close()">
  <div class="column-filter-panel" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <div class="panel-title">{{ header }}</div>

    <div class="search-box">
      <label class="visually-hidden" for="column-filter-search">Search {{ header }}</label>
      <mat-icon>search</mat-icon>
      <input type="text"
        id="column-filter-search"
        #searchInput
        placeholder="Search"
        cdkFocusInitial
        [(ngModel)]="searchText"
        (ngModelChange)="onSearchChange()"
        (keydown.enter)="apply()">
      @if (searchText) {
        <button type="button" class="search-clear" aria-label="Clear search" (click)="clearSearch(searchInput)">
          <svg viewBox="0 0 10 10" width="8" height="8" aria-hidden="true">
            <path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
          </svg>
        </button>
      }
    </div>

    <div class="option-list">
      @if (visibleOptions.length > 0) {
        <label class="option select-all">
          <input type="checkbox"
            [checked]="allVisibleChecked"
            [indeterminate]="someVisibleChecked && !allVisibleChecked"
            (change)="toggleAllVisible()">
          <span>{{ searchText ? '(Select All Search Results)' : '(Select All)' }}</span>
        </label>
      }
      @for (option of visibleOptions; track option) {
        <label class="option" [title]="getLabel(option)">
          <input type="checkbox"
            [checked]="draft.has(option)"
            (change)="toggleOption(option)">
          <span>{{ getLabel(option) }}</span>
        </label>
      } @empty {
        <div class="no-matches">No matches</div>
      }
    </div>

    <div class="panel-actions">
      <span class="selection-count">{{ checkedVisibleCount }} of {{ visibleOptions.length }} selected</span>
      <button type="button" class="btn-clear" [disabled]="!isActive" (click)="clear()">Clear</button>
      <button type="button" class="btn-ok" [disabled]="!someVisibleChecked" (click)="apply()">OK</button>
    </div>
  </div>
</ng-template>
